import React, {Component} from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem} from 'reactstrap';
import PropTypes from 'prop-types';

import {AppHeaderDropdown} from '@coreui/react';
import Clock from 'react-live-clock';
import '../Reception/Style.css'
import {Label} from "semantic-ui-react";
import { Tooltip} from "antd";
import swal from "sweetalert";
import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import Cookies from "js-cookie";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import image from '../../assets/img/logos/visitor_logo.png';
import {withRouter} from 'react-router-dom'

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {

  onLogout = () => {
    swal({
      title: "Do you want to sign out?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Sign-out",
          value: "action",
          className: "remove-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {

          case "action":

            this.props.userHandler([]);
            Cookies.remove("68a6102f6ed24899420170004a0273b8");
            Cookies.remove("9b8558ba3f051677daf36ebfc67f29fa");
            this.props.history.push('/');
            break;
          default:
        }
      });
  };


  render() {
    return (
      <React.Fragment>

        <h1 className={"logo-text"}>
          <img src={image} className={"logo-style"} alt="." style={{height: '120px'}}/>
        </h1>

        {/*checkout/checkin details*/}

        <div style={{marginLeft: '10px'}}>
          <Tooltip placement="topLeft" title="Schedule Meeting">
            <Label onClick={() => this.props.history.push('/external-reception/dashboard')} color='grey' horizontal
                   style={{cursor: 'pointer'}}>
              {"Check In Visitor"}
            </Label>
          </Tooltip>

          <Tooltip placement="topLeft" title="View all not-checkout visitors">
            <Label onClick={() => this.props.history.push('/external-reception/checkout')} color='orange' horizontal
                   style={{cursor: 'pointer'}}>
              {"Not checked out : " + this.props.visitor_count_list.notCheckOut}
            </Label>
          </Tooltip>

          <Tooltip placement="topLeft" title="View all visitors">
            <Label onClick={() => this.props.history.push('/external-reception/visitorcount')} color='blue' horizontal
                   style={{cursor: 'pointer'}}>
              {"Total Visitors: " + this.props.visitor_count_list.total}
            </Label>
          </Tooltip>

          <Tooltip placement="topLeft" title="View all overdue visitors">
            <Label onClick={() => this.props.history.push('/external-reception/overdue')} color='red' horizontal
                   style={{cursor: 'pointer'}}>
              {"Overdue : " + this.props.visitor_count_list.overdue}
            </Label>
          </Tooltip>

          <Tooltip placement="topLeft" title="View all history">
            <Label onClick={() => this.props.history.push('/external-reception/history')} color='grey' horizontal
                   style={{cursor: 'pointer'}}>
              {"History Viewer"}
            </Label>
          </Tooltip>

        </div>

        {/*date and time, dddd, YYYY MMMM D h:mm:ssa / YYYY M D h:mm:ssa*/}
        <Clock style={{fontSize: '14px', color: 'black', marginLeft: '25px'}} format="dddd, D-MMMM-YYYY | h:mm:ss A"
               ticking={true} interval={1000}/>

        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <span style={{
                fontSize: '16px',
                color: '#585858',
                fontWeight: '600',
                marginRight:'10px',
              }}>{this.props.usr_obj === undefined ? "Welcome admin" : "Welcome " + this.props.usr_obj.fullName}
                &nbsp;
                <i className="fa fa-caret-down"/>
              </span>

            </DropdownToggle>
            <DropdownMenu right style={{right: 'auto'}}>
              <DropdownItem onClick={e => this.onLogout(e)}><i className="fa fa-lock"/> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  history: state.historyReducer.history,
  is_spin: state.spinnerReducer.is_spin,
  usr_obj: state.userReducer.user,

  visitor_count_list: state.reception_VisitorCountReducer.visitor_count_list,
});

const mapDispatchToProps = (dispatch) => {
  return {

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // userReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DefaultHeader));
